import React, { useState } from 'react';
import './AdminLayout.css'; // Import the CSS file

function AdminLayout({ children, onLogout, onSelectSection, userPermissions }) { // Accept userPermissions prop
  const [openSection, setOpenSection] = useState(null);

  const handleSectionClick = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div className="admin-layout">
      <div className="sidebar">
        <div className="sidebar-header">
          <h1>Admin</h1>
        </div>
        <ul className="sidebar-menu">
          {userPermissions.hero && (
            <li onClick={() => onSelectSection('hero')}>
              <i className="fas fa-home"></i>
              <span>Hero</span>
            </li>
          )}
          {userPermissions.experiences && (
            <li onClick={() => onSelectSection('experiences')}>
              <i className="fas fa-star"></i>
              <span>Experiencias</span>
            </li>
          )}
          {(userPermissions.reservasSedes || userPermissions.reservations || userPermissions.reservationsManagement) && (
            <li onClick={() => handleSectionClick('reservas')} data-open={openSection === 'reservas'}>
              <i className="fas fa-calendar-alt"></i>
              <span>Reservas</span>
              <ul>
                  {userPermissions.reservasSedes && (
                    <li onClick={() => onSelectSection('reservasSedes')}>
                      <i className="fas fa-map-marker-alt"></i>
                      <span>Reservas Sedes</span>
                    </li>
                  )}
                  {userPermissions.reservations && (
                    <li onClick={() => onSelectSection('reservations')}>
                      <i className="fas fa-calendar-alt"></i>
                      <span>Registro de Reservas</span>
                    </li>
                  )}

              </ul>
            </li>
          )}
          {userPermissions.reservationsManagement && (
            <li onClick={() => onSelectSection('reservationsManagement')}>
              <i className="fas fa-motorcycle"></i>
              <span>Domicilios</span>
            </li>
          )}
          {(userPermissions.menuRecommendations || userPermissions.menuSedes || userPermissions.menuManagement || userPermissions.dishManagement) && (
            <li onClick={() => handleSectionClick('menu')} data-open={openSection === 'menu'}>
              <i className="fas fa-utensils"></i>
              <span>Menú</span>
              <ul>
                  {userPermissions.menuRecommendations && (
                    <li onClick={() => onSelectSection('menuRecommendations')}>
                      <i className="fas fa-star"></i>
                      <span>Recomendaciones</span>
                    </li>
                  )}
                  {userPermissions.menuSedes && (
                    <li onClick={() => onSelectSection('menuSedes')}>
                      <i className="fas fa-map-marker-alt"></i>
                      <span>Menú Sedes</span>
                    </li>
                  )}
                  {userPermissions.menuManagement && (
                    <li onClick={() => onSelectSection('menuManagement')}>
                      <i className="fas fa-cogs"></i>
                      <span>Gestión de Menú</span>
                    </li>
                  )}
                  {userPermissions.dishManagement && (
                    <li onClick={() => onSelectSection('dishManagement')}>
                      <i className="fas fa-plus"></i>
                      <span>Gestión de Platos</span>
                    </li>
                  )}
              </ul>
            </li>
          )}
          {(userPermissions.eventSpaces || userPermissions.eventBookings) && (
            <li onClick={() => handleSectionClick('eventos')} data-open={openSection === 'eventos'}>
              <i className="fas fa-glass-cheers"></i>
              <span>Salones</span>
              <ul>
                  {userPermissions.eventSpaces && (
                    <li onClick={() => onSelectSection('eventSpaces')}>
                      <i className="fas fa-map-marker-alt"></i>
                      <span>Espacios</span>
                    </li>
                  )}
                  {userPermissions.eventBookings && (
                    <li onClick={() => onSelectSection('eventBookings')}>
                      <i className="fas fa-calendar-alt"></i>
                      <span>Registro de reserva de salones</span>
                    </li>
                  )}
              </ul>
            </li>
          )}
          {(userPermissions.promotionsConfig || userPermissions.promotionBookings) && (
            <li onClick={() => handleSectionClick('promociones')} data-open={openSection === 'promociones'}>
              <i className="fas fa-tags"></i>
              <span>Eventos</span>
              <ul>
                  {userPermissions.promotionsConfig && (
                    <li onClick={() => onSelectSection('promotionsConfig')}>
                      <i className="fas fa-cogs"></i>
                      <span>Configuración</span>
                    </li>
                  )}
                  {userPermissions.promotionBookings && (
                    <li onClick={() => onSelectSection('promotionBookings')}>
                      <i className="fas fa-calendar-alt"></i>
                      <span>Registro de reservas de eventos</span>
                    </li>
                  )}
              </ul>
            </li>
          )}
          {userPermissions.socialLinks && (
            <li onClick={() => onSelectSection('socialLinks')}>
              <i className="fas fa-share-alt"></i>
              <span>Redes Sociales</span>
            </li>
          )}
          {userPermissions.reviews && (
            <li onClick={() => onSelectSection('reviews')}>
              <i className="fas fa-star"></i>
              <span>Reseñas</span>
            </li>
          )}
          {userPermissions.userManagement && (
            <li onClick={() => onSelectSection('userManagement')}>
              <i className="fas fa-users"></i>
              <span>Gestión de Usuarios</span>
            </li>
          )}
        </ul>
        <button className="logout-button" onClick={onLogout}>Cerrar Sesión</button>
      </div>
      <div className="main-content-wrapper">
        <div className="main-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;